import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export default class IncidentCustomers extends Component {
  constructor(props) {
    super(props);
    const removeZeros = (data) =>
      data.map((value) => (value === 0 ? null : value));
    this.state = {
      //   series: [
      //     {
      //       name: "Canceled",
      //       data: removeZeros([0, 223, 102, 35, 0, 0, 2]),
      //     },
      //     {
      //       name: "Closed",
      //       data: removeZeros([24536, 26867, 24050, 3884, 3653, 1207, 874]),
      //     },
      //     {
      //       name: "In Progress",
      //       data: removeZeros([117, 0, 0, 0, 0, 0, 0]),
      //     },
      //     {
      //       name: "New",
      //       data: removeZeros([2759, 0, 0, 0, 0, 0, 0]),
      //     },
      //     {
      //       name: "On Hold",
      //       data: removeZeros([0, 0, 5, 0, 0, 0, 0]),
      //     },
      //   ],
      series: this.props.incidentSeries,
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: false,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "80%",
            borderRadius: 1,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#605E5C"],
            fontSize: "12px",
            fontWeight: 600,
          },
          offsetY: -20,
        },
        xaxis: {
          //   categories: [
          //     "Cust 4",
          //     "Cust 5",
          //     "Cust 2",
          //     "Cust 3",
          //     "Cust 8",
          //     "Cust 9",
          //     "Cust 7",
          //   ],
          categories: this.props.incidentCategories,

          labels: {
            style: {
              fontSize: "10px",
              fontWeight: 700,
              margin: {
                top: 0, // Adjust these margins to control spacing around labels
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            rotate: -30,
          },

          title: {
            style: {
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "10px",
              fontWeight: "bold",
            },
          },
          title: {
            text: "Incidents", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
          // Use logarithmic scale
          logarithmic: true,
          min: 1, // Start from 1 since log scale does not support 0
          tickAmount: 5, // Control the number of ticks on the Y-axis
        },
        fill: {
          opacity: 1,
        },
        colors: [
          "#118DFF", // Critical
          "#F78E1E", // Information
          "#219EBC", // Major
          "#12239E", // Minor
          "#E66C37", // Warning
        ],

        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontWeight: "10px",
          //   offsetX: 40,
        },
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.incidentSeries !== this.props.incidentSeries) {
      this.setState({ series: this.props.incidentSeries });
    }
    if (prevProps.incidentCategories !== this.props.incidentCategories) {
      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: this.props.incidentCategories,
          },
        },
      });
    }
  }

  render() {
    return (
      <div>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={300}
        />
      </div>
    );
  }
}
